import store from "@/store";
import accounting from './accounting.js'
/**
 * 对象深度克隆
 *
 */
export const clone = (obj) => {
  // Handle the 3 simple types, and null or undefined
  if (obj == null || typeof obj !== 'object') return obj;

  // Handle Date
  if (obj instanceof Date) {
    var copy = new Date();
    copy.setTime(obj.getTime());
    return copy;
  }

  // Handle Array
  if (obj instanceof Array) {
    var copy = [];
    for (var i = 0; i < obj.length; ++i) {
      copy[i] = clone(obj[i]);
    }
    return copy;
  }

  // Handle Object
  if (obj instanceof Object) {
    var copy = {};
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
    }
    return copy;
  }

  throw new Error("Unable to copy obj! Its type isn't supported.");
}

/**
 * 存储localStorage
 *
 */
export const setLStore = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
}


/**
 * 获取localStorage
 *
 */
export const getLStore = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
}


/**
 * 删除localStorage
 *
 */
export const removeLStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
}


/**
 * 存储sessionStorage
 *
 */
export const setSStore = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.sessionStorage.setItem(name, content);
}
export const setSStore2 = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
}


/**
 * 获取sessionStorage
 *
 */
export const getSStore = name => {
  if (!name) return;
  return window.sessionStorage.getItem(name);
}
export const getSStore2 = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
}


/**
 * 删除sessionStorage
 *
 */
export const removeSStore = name => {
  if (!name) return;
  window.sessionStorage.removeItem(name);
}


/**
 * 获取style样式
 *
 */
export const getStyle = (element, attr, NumberMode = 'int') => {
  let target;
  // scrollTop 获取方式不同，没有它不属于style，而且只有document.body才能用
  if (attr === 'scrollTop') {
    target = element.scrollTop;
  } else if (element.currentStyle) {
    target = element.currentStyle[attr];
  } else {
    target = document.defaultView.getComputedStyle(element, null)[attr];
  }
  // 在获取 opactiy 时需要获取小数 parseFloat
  return NumberMode == 'float' ? parseFloat(target) : parseInt(target);
}


/**
 * 截取url所带参数
 *
 */
export const getQueryString = name => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  // console.log(window.location)
  // console.log(r)
  if (r != null) return unescape(r[2]);
  return null;
}


/**
 * 解析url,获取所带所有参数，JSON格式返回
 *
 */
export const parseUrl = () => {
  var arr = location.search.split('?')[1].split('&');
  var params = {};
  for (var i = 0, l = arr.length; i < l; i++) {
    var param = arr[i].split('=');
    params[param[0]] = param[1];
  }
  return params;
}


/**
 * 获取鼠标坐标位置
 *
 */
export const getMousePos = event => {
  var e = event || window.event;
  return {
    'x': e.clientX,
    'y': e.clientY
  }
}
/**
 * @param  {[type]} startDiffTime [兼容ios时间格式]
 * @param  {[type]} endDiffTime   [description]
 * @return {[type]}               [description]
 */
export const IOSTimeFormat = (time) => {
  // 将xxxx-xx-xx的时间格式，转换为 xxxx/xx/xx的格式
  if (IsValid(time)) {
    return time.replace(/\-/g, '/');
  }
  return time
}
/**
 * 各种格式化
 *
 */
export const format = (type, value) => {
  var a = '';
  switch (type) {
    case 'YYYY-MM-DD':
      var now = new Date(IOSTimeFormat(value));
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var month = month > 9 ? month : '0' + month;
      var day = now.getDate() > 9 ? now.getDate() : '0' + now.getDate();
      a = year + '-' + month + '-' + day;
      break;
    case 'YY-MM-DD':
      var now = new Date(IOSTimeFormat(value));
      var year = now.getFullYear();
      year = year + ''
      var month = now.getMonth() + 1;
      var month = month > 9 ? month : '0' + month;
      var day = now.getDate() > 9 ? now.getDate() : '0' + now.getDate();
      a = year.substring(2, 4) + '-' + month + '-' + day;
      break;
    case 'MM-DD':
      var now = new Date(IOSTimeFormat(value));
      var year = now.getFullYear();
      year = year + ''
      var month = now.getMonth() + 1;
      var month = month > 9 ? month : '0' + month;
      var day = now.getDate() > 9 ? now.getDate() : '0' + now.getDate();
      a = month + '-' + day;
      break;
    case 'YYYY/MM/DD':
      var now = new Date(value);
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var month = month > 9 ? month : '0' + month;
      var day = now.getDate() > 9 ? now.getDate() : '0' + now.getDate();
      a = year + '/' + month + '/' + day;
      break;
    case 'YYYY-MM':
      var now = new Date(IOSTimeFormat(value));
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var month = month > 9 ? month : '0' + month;
      a = year + '-' + month;
      break;
    case 'YYYYMM':
      var now = new Date(value);
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var month = month > 9 ? month : '0' + month;
      a = year + month;
      break;
    case 'YYYY-MM-DD-2':
      var now = new Date(IOSTimeFormat(value.substring(0, 10)));
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var month = month > 9 ? month : '0' + month;
      var day = now.getDate() > 9 ? now.getDate() : '0' + now.getDate();
      a = year + '-' + month + '-' + day;
      break;
    case 'YYYY.MM.DD':
      var now = new Date(value);
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var month = month > 9 ? month : '0' + month;
      var day = now.getDate() > 9 ? now.getDate() : '0' + now.getDate();
      a = year + '.' + month + '.' + day;
      break;
    case 'MM月DD日hh:mm':
      var now = new Date(value);
      var month = now.getMonth() + 1;
      var month = month > 9 ? month : '0' + month;
      var day = now.getDate() > 9 ? now.getDate() : '0' + now.getDate();
      var hours = now.getHours() > 9 ? now.getHours() : '0' + now.getHours();
      var minutes = now.getMinutes() > 9 ? now.getMinutes() : '0' + now.getMinutes();
      a = month + '月' + day + '日 ' + hours + ':' + minutes;
      break;
    case 'YYYY.MM.DD hh:mm':
      var now = new Date(value);
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var month = month > 9 ? month : '0' + month;
      var day = now.getDate() > 9 ? now.getDate() : '0' + now.getDate();
      var hours = now.getHours() > 9 ? now.getHours() : '0' + now.getHours();
      var minutes = now.getMinutes() > 9 ? now.getMinutes() : '0' + now.getMinutes();
      a = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes;
      break;
    case 'hh:mm':
      var now = new Date(value);
      var hours = now.getHours() > 9 ? now.getHours() : '0' + now.getHours();
      var minutes = now.getMinutes() > 9 ? now.getMinutes() : '0' + now.getMinutes();
      a = hours + ':' + minutes;
      break;
    case '00.00%':
      a = (value * 100).toFixed(2).toString() + '%';
      break;
    case '00%':
      a = (value * 100).toFixed(0).toString() + '%';
      break;
    case '00.00':
      a = (value * 100).toFixed(2).toString();
      break;
    case 'html':
      value = value.replace(/(\n)/g, '');
      value = value.replace(/(\t)/g, '');
      value = value.replace(/(\r)/g, '');
      value = value.replace(/<\/?[^>]*>/g, '');
      value = value.replace(/\s*/g, '');
      a = value;
      break;
  }
  return a
}


/**
 * 抽取对象的某key对应的value 成 新的数组
 *
 */
export const arrayByJson = (array, key) => {
  var b = [];
  if (key == 'dataDate' || key == 'netDate' || key == 'DATADATE') {
    array.forEach(function (obj) {
      b.push(obj[key].substring(0, 10))
    });
  } else {
    array.forEach(function (obj) {
      if (obj[key] == null || obj[key] == undefined || obj[key] == NaN) {
        b.push('-');
      } else {
        b.push(obj[key])
      }
    });
  }

  return b;
}

/**
 * 截取第n个某符号前的字符串
 *
 */
export const splitString = (stringOne, stringTwo, index) => {
  // console.log(stringOne);
  var arr = stringOne.split(stringTwo);
  var returnString = '';
  for (var i = 0; i < index; i++) {
    returnString += arr[i] + stringTwo
  }
  return returnString;
}

/**
 * 数组中是否含有指定数组
 *
 */
export const ArrIsContained = (a, b) => {
  if (!(a instanceof Array) || !(b instanceof Array)) return false;
  if (a.length < b.length) return false;
  // 把数组转成字符串，通过indexOf来判断
  var aStr = a.toString();
  for (var i = 0, len = b.length; i < len; i++) {
    if (aStr.indexOf(b[i]) == -1) return false;
  }
  return true;
}


/**
 * oParent为父节点DOM对象，sClass为需要获取的类
 *
 */
export const getByClass = (oParent, sClass) => {
  var aEle = oParent.getElementsByTagName('*');
  var aResult = [];
  var re = new RegExp('\\b' + sClass + '\\b', 'i');
  var i = 0;
  for (i = 0; i < aEle.length; i++) {
    if (re.test(aEle[i].className)) {
      aResult.push(aEle[i]);
    }
  }
  return aResult;
  // 此处返回的是一个数组DOM对象
}


/**
 * 字符串长度截取,并在后面加上'...'
 *
 */
export const cutstr = (str, len) => {
  var temp,
    icount = 0,
    patrn = /[^\x00-\xff]/,
    strre = '';
  for (var i = 0; i < str.length; i++) {
    if (icount < len - 1) {
      temp = str.substr(i, 1);
      if (patrn.exec(temp) == null) {
        icount = icount + 1
      } else {
        icount = icount + 2
      }
      strre += temp
    } else {
      break;
    }
  }
  return strre + '...'
}


/**
 * 判断是否以某个字符串开头
 *
 */
String.prototype.startWith = function (s) {
  return this.indexOf(s) == 0
}


/**
 * 判断是否以某个字符串结尾
 *
 */
String.prototype.endWith = function (s) {
  var d = this.length - s.length;
  return (d >= 0 && this.lastIndexOf(s) == d)
}


/**
 * 根据数据取得在数组中的索引
 *
 */
Array.prototype.getIndex = function (obj) {
  for (var i = 0; i < this.length; i++) {
    if (obj == this[i]) {
      return i;
    }
  }
  return -1;
}


/**
 * 移除数组中的某元素
 *
 */
Array.prototype.remove = function (obj) {
  for (var i = 0; i < this.length; i++) {
    if (obj == this[i]) {
      this.splice(i, 1);
      break;
    }
  }
  return this;
}


/**
 * 去重方法
 *
 */
Array.prototype.unique = function () {
  var res = [];
  var json = {};
  for (var i = 0; i < this.length; i++) {
    if (!json[this[i]]) {
      res.push(this[i]);
      json[this[i]] = 1;
    }
  }
  return res;
}


/**
 * 判断元素是否在数组中
 *
 */

Array.prototype.contains = function (obj) {
  for (var i = 0; i < this.length; i++) {
    if (obj == this[i]) {
      return true;
    }
  }
  return false;
}


/**
 * 判断元素是否在数组中
 *
 */

Array.prototype.contains = function (obj) {
  for (var i = 0; i < this.length; i++) {
    if (obj == this[i]) {
      return true;
    }
  }
  return false;
}


/**
 * 数组每隔几个数取一次
 *
 */
Array.prototype.arrayExtract = function (num) {
  var arr_new = [];
  arr_new.push(this[0]);
  if (this.length % num) {
    for (var a = 1; a <= (this.length / num); a++) {
      arr_new.push(this[a * num])
    }
  } else {
    for (var a = 1; a < (this.length / num); a++) {
      arr_new.push(this[a * num])
    }
    arr_new.push(this[this.length - 1])
  }

  return arr_new;
}

/**
 * 数组最小值
 *
 */
Array.prototype.min = function () {
  var min = this[0];
  var len = this.length;
  for (var i = 1; i < len; i++) {
    if (this[i] < min) {
      min = this[i];
    }
  }
  return min;
}

/**
 * 数组最大值
 *
 */

Array.prototype.max = function () {
  var max = this[0];
  var len = this.length;
  for (var i = 1; i < len; i++) {
    if (this[i] > max) {
      max = this[i];
    }
  }
  return max;
}


/**
 * 数组最大值
 *
 */

Array.prototype.spliceArray = function (a, b, c) {
  c.forEach((c_c, index) => {
    this.splice(a, b, c_c)
  })
  return this;
}



/**
 * 回到顶部
 * elId--可滚动盒子id, btnId--回到顶部按钮id
 */
export const backTop = (elId, btnId) => {
  var btn = document.getElementById(btnId);
  var d = document.documentElement;
  var b = document.getElementById(elId);
  b.onscroll = set;
  // btn.style.display = "none";
  btn.onclick = function () {
    btn.style.display = 'none';
    window.onscroll = null;
    this.timer = setInterval(function () {
      d.scrollTop -= Math.ceil((d.scrollTop + b.scrollTop) * 0.1);
      b.scrollTop -= Math.ceil((d.scrollTop + b.scrollTop) * 0.1);
      if ((d.scrollTop + b.scrollTop) == 0) clearInterval(btn.timer, window.onscroll = set);
    }, 30);
  };

  function set() {
    btn.style.display = (d.scrollTop + b.scrollTop > 100) ? 'block' : 'none'
  }
};
/**
 * 补全邮箱
 *
 */
export const compleInput = (attr) => {
  // document.addEventListener('keyup',attr.nameInput,()=>{
  //
  // })
  // $(document).on('keyup',,function(){
  //   $(attr.userNameInput).val(pinyin.getFullChars($(attr.nameInput).val()));
  //   $(attr.emailInput).val($(attr.userNameInput).val()+'@cjhxfund.com');
  // })

}


/**
 * 数字每隔三位加逗号
 *
 */
export const numWithDot = (str) => {
  if (str < 0) {
    var str_first = '-'
    str = -str
  } else {
    var str_first = ''
  }
  var str = '' + str;
  var newStr = '';
  var count = 0;

  if (str.indexOf('.') == -1) {
    for (var i = str.length - 1; i >= 0; i--) {
      if (count % 3 == 0 && count != 0) {
        newStr = str.charAt(i) + ',' + newStr;
      } else {
        newStr = str.charAt(i) + newStr;
      }
      count++;
    }
    // str = newStr + ".00"; //自动补小数点后两位
    str = newStr;
  } else {
    for (var i = str.indexOf('.') - 1; i >= 0; i--) {
      if (count % 3 == 0 && count != 0) {
        newStr = str.charAt(i) + ',' + newStr;
      } else {
        newStr = str.charAt(i) + newStr; // 逐个字符相接起来
      }
      count++;
    }
    str = newStr + (str + '00').substr((str + '00').indexOf('.'), 3);
  }
  return str_first + str;
}


/**
 * 平滑变化
 *
 */
export const animate = (obj, json, interval, sp, fn) => {
  if (IsValid(obj.timer)) {
    clearInterval(obj.timer);
  }
  // var k = 0;
  // var j = 0;
  function getStyle(obj, arr) {
    if (obj.currentStyle) {
      return obj.currentStyle[arr]; // 针对ie
    } else {
      return document.defaultView.getComputedStyle(obj, null)[arr];
    }
  }
  obj.timer = setInterval(function () {
    // j ++;
    var flag = true;
    for (var arr in json) {
      var icur = 0;
      // k++;
      if (arr == 'opacity') {
        icur = Math.round(parseFloat(getStyle(obj, arr)) * 100);
      } else if (arr == 'scrollTop') {
        icur = obj.scrollTop
      } else if (arr == 'scrollLeft') {
        icur = obj.scrollLeft
      } else {
        icur = parseInt(getStyle(obj, arr));
      }
      var speed = (json[arr] - icur) * sp;
      speed = speed > 0 ? Math.ceil(speed) : Math.floor(speed);
      if (icur != json[arr]) {
        flag = false;
      }
      if (arr == 'opacity') {
        obj.style.filter = "alpha(opacity : '+(icur + speed)+' )";
        obj.style.opacity = (icur + speed) / 100;
      } else if (arr == 'scrollTop') {
        obj.scrollTop = icur + speed;
      } else if (arr == 'scrollLeft') {
        obj.scrollLeft = icur + speed;
      } else {
        obj.style[arr] = icur + speed + 'px';
      }
      // console.log(j + "," + arr +":"+ flag);
    }

    if (flag) {
      clearInterval(obj.timer);
      // console.log(j + ":" + flag);
      // console.log("k = " + k);
      // console.log("j = " + j);
      // console.log("DONE");
      if (fn) {
        fn();
      }
    }
  }, interval);
}


/**
 * 运动曲线函数
 * 调用方式
 */
export const Tween = {
  Linear: function (t, b, c, d) {
    return c * t / d + b;
  },
  Quad: {
    easeIn: function (t, b, c, d) {
      return c * (t /= d) * t + b;
    },
    easeOut: function (t, b, c, d) {
      return -c * (t /= d) * (t - 2) + b;
    },
    easeInOut: function (t, b, c, d) {
      if ((t /= d / 2) < 1) return c / 2 * t * t + b;
      return -c / 2 * ((--t) * (t - 2) - 1) + b;
    }
  },
  Cubic: {
    easeIn: function (t, b, c, d) {
      return c * (t /= d) * t * t + b;
    },
    easeOut: function (t, b, c, d) {
      return c * ((t = t / d - 1) * t * t + 1) + b;
    },
    easeInOut: function (t, b, c, d) {
      if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
      return c / 2 * ((t -= 2) * t * t + 2) + b;
    }
  },
  Quart: {
    easeIn: function (t, b, c, d) {
      return c * (t /= d) * t * t * t + b;
    },
    easeOut: function (t, b, c, d) {
      return -c * ((t = t / d - 1) * t * t * t - 1) + b;
    },
    easeInOut: function (t, b, c, d) {
      if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
      return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
    }
  },
  Quint: {
    easeIn: function (t, b, c, d) {
      return c * (t /= d) * t * t * t * t + b;
    },
    easeOut: function (t, b, c, d) {
      return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    },
    easeInOut: function (t, b, c, d) {
      if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
      return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    }
  },
  Sine: {
    easeIn: function (t, b, c, d) {
      return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
    },
    easeOut: function (t, b, c, d) {
      return c * Math.sin(t / d * (Math.PI / 2)) + b;
    },
    easeInOut: function (t, b, c, d) {
      return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
    }
  },
  Expo: {
    easeIn: function (t, b, c, d) {
      return (t == 0) ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
    },
    easeOut: function (t, b, c, d) {
      return (t == d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
    },
    easeInOut: function (t, b, c, d) {
      if (t == 0) return b;
      if (t == d) return b + c;
      if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
      return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
    }
  },
  Circ: {
    easeIn: function (t, b, c, d) {
      return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
    },
    easeOut: function (t, b, c, d) {
      return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
    },
    easeInOut: function (t, b, c, d) {
      if ((t /= d / 2) < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
      return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
    }
  },
  Elastic: {
    easeIn: function (t, b, c, d, a, p) {
      if (t == 0) return b;
      if ((t /= d) == 1) return b + c;
      if (!p) p = d * 0.3;
      if (!a || a < Math.abs(c)) {
        a = c;
        var s = p / 4;
      } else var s = p / (2 * Math.PI) * Math.asin(c / a);
      return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    },
    easeOut: function (t, b, c, d, a, p) {
      if (t == 0) return b;
      if ((t /= d) == 1) return b + c;
      if (!p) p = d * 0.3;
      if (!a || a < Math.abs(c)) {
        a = c;
        var s = p / 4;
      } else var s = p / (2 * Math.PI) * Math.asin(c / a);
      return (a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b);
    },
    easeInOut: function (t, b, c, d, a, p) {
      if (t == 0) return b;
      if ((t /= d / 2) == 2) return b + c;
      if (!p) p = d * (0.3 * 1.5);
      if (!a || a < Math.abs(c)) {
        a = c;
        var s = p / 4;
      } else var s = p / (2 * Math.PI) * Math.asin(c / a);
      if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
      return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
    }
  },
  Back: {
    easeIn: function (t, b, c, d, s) {
      if (s == undefined) s = 1.70158;
      return c * (t /= d) * t * ((s + 1) * t - s) + b;
    },
    easeOut: function (t, b, c, d, s) {
      if (s == undefined) s = 1.70158;
      return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    },
    easeInOut: function (t, b, c, d, s) {
      if (s == undefined) s = 1.70158;
      if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= (1.525)) + 1) * t - s)) + b;
      return c / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2) + b;
    }
  },
  Bounce: {
    easeIn: function (t, b, c, d) {
      return c - Tween.Bounce.easeOut(d - t, 0, c, d) + b;
    },
    easeOut: function (t, b, c, d) {
      if ((t /= d) < (1 / 2.75)) {
        return c * (7.5625 * t * t) + b;
      } else if (t < (2 / 2.75)) {
        return c * (7.5625 * (t -= (1.5 / 2.75)) * t + 0.75) + b;
      } else if (t < (2.5 / 2.75)) {
        return c * (7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375) + b;
      } else {
        return c * (7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375) + b;
      }
    },
    easeInOut: function (t, b, c, d) {
      if (t < d / 2) return Tween.Bounce.easeIn(t * 2, 0, c, d) * 0.5 + b;
      else return Tween.Bounce.easeOut(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
    }
  }
}


/**
 * 最近几个月
 *
 */
export const recentMonth = (payload) => {
  console.log(payload)

  if (payload.time != undefined) {
    var end = new Date(payload.time);
    var start = new Date(payload.time);
  } else {
    var end = new Date();
    var start = new Date();
  }
  if (payload.val == 'year') {
    start = payload.time.getFullYear() + '-01-01';
  } else if (payload.val == 12) {
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
  } else if (payload.val == 6) {
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 182);
  } else {
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 31 * payload.val);
  }

  return [format('YYYY-MM-DD', start), format('YYYY-MM-DD', end)]
}

/**
 * 是否小于x天
 *
 */
export const littleThenDay = (day, time) => {
  var a = new Date();
  var d = new Date(time);
  if (a - d > 3600 * 1000 * 3) {
    return true;
  } else {
    return false;
  }

  console.log(a);
  console.log(b);
  console.log(a - b);
}


// 首字母大写
export const replaceStr1 = (str) => {
  str = str.toLowerCase();
  var strTemp = ''; // 新字符串
  for (var i = 0; i < str.length; i++) {
    if (i == 0) {
      strTemp += str[i].toUpperCase(); // 第一个
      continue;
    }
    if (str[i] == ' ' && i < str.length - 1) { // 空格后
      strTemp += ' ';
      strTemp += str[i + 1].toUpperCase();
      i++;
      continue;
    }
    strTemp += str[i];
  }
  return strTemp;
}


/**
 * debounce 延时执行js
 *
 *
 */
var now = Date.now || function () {
  return new Date().getTime();
};


export const debounce = (func, wait, immediate) => {
  var timeout, args, context, timestamp, result;

  console.log('jinlaile')

  var later = function () {
    var last = now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function () {
    context = this;
    args = arguments;
    timestamp = now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

export const getImgsrc = (htmlstr) => {
  var reg = /<img.+?src=('|")?([^'"]+)('|")?(?:\s+|>)/gim;
  var arr = [];
  var tem = null;

  if (tem = reg.exec(htmlstr)) {
    return tem[2]
  } else {
    return '';
  }
}


/**
 * 获取文件类型  返回如 '.doc','.ppt'
 *
 */
export const getFileType = (str) => {
  var index1 = str.lastIndexOf('.');
  var index2 = str.length;
  var postf = str.substring(index1, index2); // 后缀名
  return postf;
}

/**
 * 获取对象成员个数
 *
 */
export const keyCount = (o) => {
  var t = typeof o;
  if (t == 'string') {
    return o.length;
  } else if (t == 'object') {
    var n = 0;
    for (var i in o) {
      n++;
    }
    return n;
  }
  return false;
}
/**
 * 路由跳转, this: 当前对象
 *
 */
export const pushRouter = (self, path, query) => {
  self.router.push({
    path,
    query: query
  })
}
/**
 * 验证身份证
 *
 */
export const IdentityCodeValid = (code) => {
  var city = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江 ',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北 ',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏 ',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外 '
  };
  var tip = '';
  var pass = true;
  if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
    tip = '身份证号格式错误';
    pass = false;
  } else if (!city[code.substr(0, 2)]) {
    tip = '地址编码错误';
    pass = false;
  } else {
    // 18位身份证需要验证最后一位校验位
    if (code.length == 18) {
      code = code.split('');
      // ∑(ai×Wi)(mod 11)
      // 加权因子
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      // 校验位
      var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
      var sum = 0;
      var ai = 0;
      var wi = 0;
      for (var i = 0; i < 17; i++) {
        ai = code[i];
        wi = factor[i];
        sum += ai * wi;
      }
      var last = parity[sum % 11];
      if (parity[sum % 11] != code[17]) {
        tip = '校验位错误';
        pass = false;
      }
    }
  }
  // if(!pass) alert(tip);
  return pass;
}
/**
 * 验证登录密码格式 6-16位以字母开头包含数字或下划线
 *
 */
export const PasswordValid = (code) => {
  return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(code)
}
/**
 * 验证交易密码格式 6位数字
 *
 */
export const DealPasswordValid = (code) => {
  return /^\d{6}$/.test(code)
}
/**
 * 验证手机号码
 *
 */
export const MobileValid = (code) => {
  return /^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/.test(code)
}
/**
 * 验证固定电话
 *
 */
export const fixedTelValid = (code) => {
  return /^\d{3}-\d{8}|\d{4}\d{7}$/.test(code)
}
/**
 * 验证邮箱
 *
 */
export const EmailValid = (code) => {
  return /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(code)
}
/**
 * 验证邮政编码
 *
 */
export const PostalCodeValid = (code) => {
  return /^[0-9]{6}$/.test(code)
}
/**
 * 验证金额
 *
 */
export const MoneyValid = (code) => {
  return /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(code)
}
/**
 * 验证字符是否有效
 *
 */
export const IsValid = (code) => {
  if (code === '' || code === undefined || code === null) return false
  return true
}
/**
 * 是否到达底部 返回标志位
 *
 */
export const IsBottom = (code) => {
  // body距离顶部距离
  var bodyTop = document.documentElement.scrollTop || document.body.scrollTop
  // body的高度
  var bodyHeight = document.documentElement.scrollHeight || document.body.scrollHeight
  // 屏幕高度
  var screenHeight = document.documentElement.clientHeight || document.body.clientHeight
  // body和屏幕高度差
  var altitudeIntercept = bodyHeight - screenHeight
  if (altitudeIntercept - bodyTop < 10) {
    console.log('离底部小于10px')
    return true
  }
  return false
}
/**
 * 获取小数前字符
 *
 */
export const getBefore = (code) => {
  code = parseFloat(code) * 100
  code += ''
  return code.split('.')[0]
}
/**
 * 获取小数点后两位数
 *
 */
export const getHind = (code) => {
  code = parseFloat(code) * 100
  code += ''
  if (code.split('.').length === 1) {
    code += '.00'
  }
  return code.split('.')[1].substring(0, 2)
}
/**
 * 将对象数组某一个字段全部以符号拼接成字符串
 *
 */
export const Joint = (array, code) => {
  var result = ''
  array.forEach((item, index) => {
    result += item[code]
    if (index < array.length - 1) {
      result += ','
    }
  })
  return result
}

/**
 * 传入key，获取URL参数，解决vue router里有时会获取不到对象
 *
 */
export const hashQuery = (key) => {
  try {
    var hash = window.location.hash
    var hashArr = hash.indexOf('?')!==-1?hash.split('?')[1].split('&'):[]
    var hashObj = {}
    hashArr.forEach(item => {
      var arr = item.split('=')
      // hashObj.push({key: arr[0], value: arr[1]})
      hashObj[arr[0]] = arr[1]
    })
    if (IsValid(hashObj[key])) {
      return hashObj[key]
    } else {
      return ''
    }
  } catch (err) {
    console.log(err)
  }
}

/**
 * 银行图标配置
 *
 */
export const bankIcon = (name) => {
  var bank = {
    "广东发展银行": 'BankOfGF',
    "华夏银行": 'BankOfHX',
    "平安银行": 'BankOfPA',
    "上海浦东发展银行": 'BankOfPF',
    "上海银行": 'BankOfSH',
    "兴业银行": 'BankOfXY',
    "邮政储蓄银行": 'BankOfUC',
    "招商银行": 'BankOfZS',
    "中国工商银行": 'BankOfGS',
    "中国光大银行": 'BankOfGD',
    "中国建设银行": 'BankOfJS',
    "中国交通银行": 'BankOfJT',
    "中国民生银行": 'BankOfMS',
    "中国农业银行": 'BankOfNY',
    "中国银行": 'BankOfChina',
    "中信银行": 'BankOfZX',
    "北京银行": 'BankOfBJ'
  };
  return bank[name];
}
export const deviceIsIOS = () => {
  const u = navigator.userAgent;
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  return isIOS;
};
export const saveToken = (token) => {
  setLStore("token", token);
  setSStore("token", token);
  store.state.logined = true;
};
export const clearLogined = (cb) => {
  removeLStore("token");
  removeSStore("token");
  removeSStore("personalCenterUserInfo");
  store.state.logined = false;
  // sessionStorage.clear()
  // localStorage.clear();
  cb && cb();
};
export const setChannel = () => {
  const {
    mccode = "", sccode = "", location = ""
  } = getChannel();
  setSStore("mccode", hashQuery("mccode") || mccode || "wx");
  setSStore("sccode", hashQuery("sccode") || sccode || "wx_gzh");
  setSStore("location", hashQuery("location") || location || "menu_bar");
};
export const getChannel = () => {
  return {
    mccode: getSStore("mccode"),
    sccode: getSStore("sccode"),
    location: getSStore("location")
  }
};
export const isCjWxChannel = () => {
  const {
    mccode,
    sccode
  } = getChannel();
  return mccode === "wx" && sccode === "wx_gzh"
};
export const setRoutePage = (routePage) => {
  setSStore("routePage", routePage);
};
export const getRoutePage = () => {
  return getSStore("routePage");
};

/**
* 格式化银行卡方法
*
*/
export const bankFormat = (val) => {
  const value = val.toString().replace(/\s/g,'').replace(/(\d{4})(?=\d)/g,"$1 ")
  return value
  }

/**
* 格式化金额方法
*
*/
export function formatCurrency(number, index) {
    if (number === 0 || number === '0' || number) {
      if (number.toString().indexOf(',')) {
        number = number
        .toString()
        .split(',')
        .join('')
        }
        let index1 = 2
        index === 0 ? (index1 = 0) : (index1 = 2)
        return accounting.formatNumber(number, index1)
        } else {
        return ''
      }
    }


    /**
 * 获取鑫账户基础链接
 *
 */
export const getXAccountUrl = (path, index) => {
  // index等于0为未开通，1为充值，2为去首页
  path = path || '';
  let url = 'http://10.191.0.47:8887/account-h5/#/';
  // 开发环境
  if (window.location.hostname == "127.0.0.1") {
    url = 'http://10.201.226.119:3000/#/';
  }
  // 测试环境
  if (window.location.hostname == "10.191.0.47") {
    url = 'http://10.191.0.47:8887/account-h5/#/';
  }
  // 测试环境外网域名
  if (window.location.hostname == 'wxzxtest2.cjhxfund.com') { // 测试环境1
  // if (window.location.hostname == 'wxaxzhtest.cjhxfund.com') { // wx3.4.0 老鑫账户嵌入微信
    url = 'http://xaccounttest.cjhxfund.com:8887/account-h5/#/';
  }
  // 生产环境
  if (window.location.hostname == 'wx.cjhxfund.com') { // 没有接入鑫账户
  // if (window.location.hostname == 'wxaxzh.cjhxfund.com') {
    url = 'https://wmsc.cjhxfund.com/account-h5/#/';
  }
  if (window.location.hostname == 'wxstg1.cjhxfund.com') { // 测试环境2
    // if (window.location.hostname == 'wxaxzhtest.cjhxfund.com') { // wx3.4.0 老鑫账户嵌入微信
      url = 'http://xaccounttest.cjhxfund.com:8887/account-h5/#/';
    }
  let query = {}
  const {
    tradeSource= '',custId="", mobile="",loginCode=""
  }  = JSON.parse(getSStore("personalCenterUserInfo"));
  if(index === '0') {
    query = {
      tradeSource,
      customerId:custId,
      regPhoneNo: mobile
    };
  } else if(index === '1') {
    query = {
      tradeSource,
      encryToken:loginCode
    };
  }
  query.redirectUrl = encodeURIComponent(location.href);
  url = `${url}${handleQuery (path, query)}`;
  return url;
};

    /**
 * 目标小火车基础链接
 *
 */
export const getXAccountUrl2 = (path, index, dataVal) => {
  // index等于0为小目标，1为我的小目标，2交易详情
  path = path || '';
  let url = 'http://10.191.0.47:8887/train-mobile/#/';
  // 测试环境1
  if (window.location.hostname == "10.191.0.47") {
    url = 'http://10.191.0.47:8887/train-mobile/#/';
  }
  // 测试环境2
  if (window.location.hostname == "10.191.0.142") {
    url = 'http://10.191.0.47:8887/train-mobile/#/';
  }

  // 测试环境1
  if (window.location.hostname == "wxzxtest2.cjhxfund.com") {
    url = 'https://traintest.cjhxfund.com/train-mobile/#/';
  }

  // 测试环境2
  if (window.location.hostname == "wxstg1.cjhxfund.com") {
    url = 'https://traintest.cjhxfund.com/train-mobile/#/';
  }

  // 生产环境
  if (window.location.hostname == "wx.cjhxfund.com") {
    url = 'https://wmsc.cjhxfund.com/train-mobile/#/';
  }
  // // 测试环境外网域名
  // if (window.location.hostname == 'wxzxtest2.cjhxfund.com') { // 测试环境1
  //   url = 'http://xaccounttest.cjhxfund.com:8887/account-h5/#/';
  // }
  // // 生产环境
  // if (window.location.hostname == 'wx.cjhxfund.com') {
  //   url = 'https://wmsc.cjhxfund.com/account-h5/#/';
  // }
  // if (window.location.hostname == 'xzhtest.cjhxfund.com') { // 测试环境2
  //   url = 'http://xaccounttest.cjhxfund.com:8887/account-h5/#/';
  // }
  let query = {}
  // const {
  //   token = ''
  // }  = JSON.parse(getSStore("token"));
  if(index === '0') {
    query = {
      token: getSStore("token"),
      channelCode: 'WXZX'
    };
  } else if(index === '1') {
    query = {
      token: getSStore("token"),
    };
  } else if(index === '2') {
    query = {
      token: getSStore("token"),
      tradeId:dataVal
    };
  } else if(index === '3') {
    query = {
      token: getSStore("token"),
      trainNo:dataVal
    };
  }
  query.redirectUrl = encodeURIComponent(location.href);
  url = `${url}${handleQuery (path, query)}`;
  return url;
};

/**
 * 处理链接参数
 *
 */
export const handleQuery = (path, query) => {
  path = path || '';
  query = query || {};
  let quertStr = '';
  if (Object.keys(query).length > 0) {
    for (const key in query) {
      const value = query[key];
      if (value) {
        quertStr = `${quertStr}&${key}=${value}`;
      }
    }
  }

  if (quertStr) {
    if (path.indexOf('?') === -1) {
      quertStr = `?${quertStr.slice (1)}`;
    }
  }
  path = `${path}${quertStr}`;
  return path;
};

    /**
 * 销户基础链接
 *
 */
export const getXAccountUrl3 = (path, index, dataVal) => {
  path = path || '';
  console.log(window.location.hostname, 'window.location.hostname');
  let url = 'http://10.191.0.47:8070/acctCancelH5/#/';
  // 测试环境
  if (window.location.hostname == "10.191.0.47") {
    url = 'http://10.191.0.47:8070/acctCancelH5/#/';
  }
  // 测试环境
  if (window.location.hostname == "10.191.0.142") {
    url = 'http://10.191.0.47:8070/acctCancelH5/#/';
  }
  if (window.location.hostname == "wxzxtest2.cjhxfund.com") {
    url = 'https://mvfundtest.cjhxfund.com/acctCancelH5/#/';
  }
  if (window.location.hostname == "wxstg1.cjhxfund.com") {
    url = 'https://mvfundtest.cjhxfund.com/acctCancelH5/#/';
  }
  // 生产环境
  if (window.location.hostname == "wx.cjhxfund.com") {
    url = 'https://optrep.cjhxfund.com/acctCancelH5/#/';
  }
  let query = {}
  const identityNo = JSON.parse(getSStore("personalCenterUserInfo")).identityNo
  const serialNo = JSON.parse(getSStore("personalCenterUserInfo")).custId
  if(index === '1') {
    query = {
      source: '1',
      identityNo: identityNo,
      channel: 'WX',
      serialNo: serialNo
    };
  }
  query.redirectUrl = encodeURIComponent(location.href);
  url = `${url}${handleQuery (path, query)}`;
  return url;
};

/**
 * 处理链接上的参数返回对象
 *
 */
export const getUrlObj = path => {
  const urlReg = /^[^\?]+\?([\w\W]+)$/
  const pathReg = /([^&=]+)=([\w\W]*?)(&|$|#)/g
  var arrUrl = urlReg.exec(path)
  var ret = {}
  if (arrUrl && arrUrl[1]) {
    var strpath = arrUrl[1],result;
    while ((result = pathReg.exec(strpath))!== null) {
      ret[result[1]] = result[2]
    }
  }
  return ret
}


/*函数节流*/
export function throttle(fn, interval) {
  var enterTime = 0; //触发的时间
  var gapTime = interval || 3500; //间隔时间，如果interval不传，则默认300ms
  return function () {
    var context = this;
    var backTime = new Date(); //第一次函数return即触发的时间
    if (backTime - enterTime > gapTime) {
      fn.call(context, arguments[0]);
      enterTime = backTime; //赋值给第一次触发的时间，这样就保存了第二次触发的时间
    }
  };
}



// WEBPACK FOOTER //
// ./src/assets/js/public/mUtils.js